import { useQuery } from '@tanstack/react-query';
import { PROGRAM_INSTANCE_QUERY_KEY } from './constants';
import { fetchProgramInstance } from './api';

export const getProgramInstanceQueryOptions = (programInstanceId?: string) => {
  return {
    queryKey: [PROGRAM_INSTANCE_QUERY_KEY, programInstanceId],
    queryFn: () => fetchProgramInstance(programInstanceId),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: !!programInstanceId,
  };
};

export const useProgramInstance = (programInstanceId?: string) => {
  const { data } = useQuery(getProgramInstanceQueryOptions(programInstanceId));

  return { programInstanceData: data?.programInstance };
};
